export type Feature =
  | { allowLocales: string[] }
  | { not: { allowLocales: string[] } };

export type FeaturesConfig<T extends string = string> = Partial<
  Record<T, Feature>
>;

function evaluateFeature(feature: Feature, locale: string): boolean {
  if ('allowLocales' in feature) {
    return feature.allowLocales.includes(locale);
  }
  return !feature.not.allowLocales.includes(locale);
}

export function getFeatures<T extends string = string>(
  config: FeaturesConfig<T>,
  locale: string,
): Record<T, boolean> {
  return Object.entries(config).reduce<Record<string, boolean>>(
    (acc, [key, feature]) => {
      if (feature !== undefined) {
        acc[key] = evaluateFeature(feature as Feature, locale);
      }
      return acc;
    },
    {},
  ) as Record<T, boolean>;
}
